var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#D2F34C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1812 28.3721C46.5009 29.9904 46.4541 33.4393 44.0913 34.9941L33.2192 42.1483C30.5675 43.8932 27.0373 42.0023 27.0205 38.8279L26.9423 24.0344C26.9252 20.7916 30.5713 18.8773 33.2309 20.7327L44.1812 28.3721Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoButton);
export default __webpack_public_path__ + "static/media/VideoButton.61d5c6a5ec047fe45795ad16aa794693.svg";
export { ForwardRef as ReactComponent };